module.exports = __webpack_public_path__ + "ath_game_web/img/9.4.80045ed5.png";